"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Collapse = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactstrap = require("reactstrap");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Collapse = (0, _styledComponents.default)(_reactstrap.UncontrolledCollapse).attrs(function (_ref) {
  var children = _ref.children;
  return {
    children: /*#__PURE__*/_react.default.createElement("div", null, children)
  };
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  & > div > * {\n    padding: 10px 0;\n    &:first-child {\n      padding-top: 28px;\n    }\n    &:last-child {\n      padding-bottom: 0;\n    }\n  }\n"])));
exports.Collapse = Collapse;